<template>
    <svg fill="#48B6E7" height="15" viewBox="0 0 18 15" width="18" xmlns="http://www.w3.org/2000/svg">
        <g fill-rule="nonzero">
            <path
                d="M15.246 0H7.739a4.416 4.416 0 0 0-3.38 1.61l-.05.056L.254 6.671a1.146 1.146 0 0 0 0 1.438l4.06 5.045a4.4 4.4 0 0 0 3.38 1.632h7.608A2.892 2.892 0 0 0 18 12.045V2.804C17.98 1.273 16.762.034 15.246 0zm.501 11.902a.634.634 0 0 1-.63.609H7.794a2.138 2.138 0 0 1-1.78-.836L2.557 7.393l3.447-4.254a2.144 2.144 0 0 1 1.769-.864h7.377c.389 0 .563.227.597.568v9.06z"
            />
            <path
                d="M13.18 9.068l-.391-.392a1.09 1.09 0 1 0-1.541 1.541l.392.392a1.09 1.09 0 1 0 1.54-1.54zM13.155 4.208a1.18 1.18 0 0 0-1.668 0h.006L9.967 5.727 8.441 4.202a1.18 1.18 0 0 0-1.667 1.666L8.3 7.393 6.774 8.918a1.177 1.177 0 1 0 1.667 1.666l4.714-4.71c.46-.46.46-1.206 0-1.666z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "KeywordShortCut",
};
</script>
